import { combineReducers } from 'redux';

import createActivitiesReducer from '/druid/reducers/createActivitiesReducer';
import createInternalReducer from '/druid/reducers/createInternalReducer';
import createNotificationsReducer from '/druid/reducers/createNotificationsReducer';
import createTypingReducer from '/druid/reducers/createTypingReducer';
import connectivityStatus from '/druid/reducers/connectivityStatus';
import dictateInterims from '/druid/reducers/dictateInterims';
import dictateState from '/druid/reducers/dictateState';
import language from '/druid/reducers/language';
import readyState from '/druid/reducers/readyState';
import referenceGrammarID from '/druid/reducers/referenceGrammarID';
import sendBoxValue from '/druid/reducers/sendBoxValue';
import sendTimeout from '/druid/reducers/sendTimeout';
import sendTypingIndicator from '/druid/reducers/sendTypingIndicator';
import shouldSpeakIncomingActivity from '/druid/reducers/shouldSpeakIncomingActivity';
import suggestedActions from '/druid/reducers/suggestedActions';

import type { GlobalScopePonyfill } from '/druid/types/GlobalScopePonyfill';

export default function createReducer(ponyfill: GlobalScopePonyfill) {
  return combineReducers({
    activities: createActivitiesReducer(ponyfill),
    connectivityStatus,
    dictateInterims,
    dictateState,
    internal: createInternalReducer(ponyfill),
    language,
    notifications: createNotificationsReducer(ponyfill),
    readyState,
    referenceGrammarID,
    sendBoxValue,
    sendTimeout,
    sendTypingIndicator,
    shouldSpeakIncomingActivity,
    suggestedActions,
    typing: createTypingReducer(ponyfill)
  });
}
